import { produce } from 'immer'
import { ActionType, getType } from 'typesafe-actions'

import {
  deleteStandardAvailabilityByIdAction,
  fetchStandardAvailabilityAction,
} from './actions'
import { StandardAvailabilityState } from './standardAvailability.types'
import { emptyNormalizedStandardAvailabilityData } from './standardAvailability.utils'

export const initialState: StandardAvailabilityState = {
  data: {},
}

const actions = {
  deleteStandardAvailabilityByIdAction,
  fetchStandardAvailabilityAction,
}

type StandardAvailabilityActionsTypes = ActionType<typeof actions>

export const standardAvailabilityReducer = (
  state = initialState,
  action: StandardAvailabilityActionsTypes,
): StandardAvailabilityState =>
  produce(state, (draft: StandardAvailabilityState) => {
    switch (action.type) {
      case getType(fetchStandardAvailabilityAction.success): {
        const normalized =
          action?.payload?.normalized || emptyNormalizedStandardAvailabilityData
        draft.data = normalized.standardAvailability

        return
      }

      case getType(deleteStandardAvailabilityByIdAction.success): {
        const { standardAvailabilityId } = action.payload
        delete draft.data[standardAvailabilityId]
        return
      }

      default:
        return
    }
  })
